export const sliceName = 'whiteboardMetrics';

export const getWhiteboardMetricsAction = `${sliceName}/getWhiteboardMetrics`;
export const getWhiteboardMetricsFiltersAction = `${sliceName}/getWhiteboardMetricsFilters`;
export const downloadWhiteboardMetricsAction = `${sliceName}/downloadWhiteboardMetrics`;
